export default __webpack_public_path__ + "e5b3139de3946782236d1933f198f016.png";